import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlText } from "@dhl-official/react-library";

export const StyledSettingsComponent = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 20px;

  @media print {
    display: none;
  }
`;

export const SettingsContainerWrapper = styled.div`
  justify-self: left;
  display: flex;
  flex-direction: column;
  border: var(--dui-size-width-border-xs) solid var(--dui-color-gray-600);
  padding: var(--dui-size-space-5x);
  background-color: var(--dui-color-white-500);

  @media screen and (min-width: ${breakpoints.desktop}) {
    flex-direction: row;
    max-width: fit-content;
  }
`;

export const SettingsCol = styled.div`
  margin-bottom: var(--dui-size-space-10x);

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-right: var(--dui-size-space-10x);
    margin-bottom: 0;
  }

  legend {
    font-weight: bold;
  }
`;

export const StyledText = styled(DhlText)`
  & > *:is(p, span) {
    word-break: break-all;
  }
`;
